import * as actionTypes from "./actionTypes";
import axios from "../../axios";
import { handleError } from "../../utils/errorHandling";

export const loadMetrics = () => (dispatch) => {
  dispatch({
    type: actionTypes.GET_METRIC_LIST_START,
    meta: {
      api: {
        method: "GET",
        endpoint: `api/v1/metrics`,
      },
    },
  });
};

export const initCreateMetric = () => (dispatch) => {
  dispatch({ type: actionTypes.CREATE_METRIC_INIT });
};

export const getMetric = (uuid) => (dispatch) => {
  dispatch({
    type: actionTypes.GET_METRIC_START,
    meta: {
      api: {
        method: "GET",
        endpoint: `api/v1/metrics/${uuid}`,
      },
    },
  });
};

export function createMetric(config, reloadMetrics) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.CREATE_METRIC_START });

    try {
      const res = await axios.post("api/v1/metrics", config);
      dispatch({ type: actionTypes.CREATE_METRIC_SUCCESS });
      if (reloadMetrics) {
        await dispatch(loadMetrics());
      }
      return res.data.data;
    } catch (err) {
      handleError(err);
      dispatch({
        type: actionTypes.CREATE_METRIC_FAIL,
        errors:
          err.response?.status === 422
            ? err.response?.data?.errors
            : [err.response?.data?.message],
      });
      throw err;
    }
  };
}

export function updateMetric(uuid, config, reloadMetrics) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_METRIC_START });

    try {
      const res = await axios.put("api/v1/metrics/" + uuid, config);
      dispatch({
        type: actionTypes.UPDATE_METRIC_SUCCESS,
        results: res.data,
      });
      if (reloadMetrics) {
        await dispatch(loadMetrics());
      }
      return res.data.data;
    } catch (err) {
      handleError(err);
      dispatch({
        type: actionTypes.UPDATE_METRIC_FAIL,
        errors:
          err.response?.status === 422
            ? err.response?.data?.errors
            : [...err.response?.data?.message],
      });
      throw err;
    }
  };
}

export const deleteMetric = (uuid) => (dispatch) => {
  dispatch({ type: actionTypes.DELETE_METRIC_START });

  axios.delete(`api/v1/metrics/${uuid}`).then((res) => {
    dispatch({ type: actionTypes.DELETE_METRIC_SUCCESS, uuid: uuid });
  });
};
